import { useDispatch } from 'react-redux';
import {
  Box, Typography, Card, CardContent, Button, Grid,
} from '@mui/material';
import CableIcon from '@mui/icons-material/Cable';
import useStyles from './style';
import request from '../../modules/Request/request';
import { openSnackbar } from '../../features/SnackBar/snackBarSlice';

function RequirementItem({ images, heading, description }) {
  const classes = useStyles();

  return (
    <Box>
      {images.map((src, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
          <img src={src} alt={heading} className={classes.image} />
          <Box>
            <Typography variant="h6" component="h4" className={classes.heading}>
              <b>{heading}</b>
            </Typography>
            <Typography variant="body2" gutterBottom>
              {description}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

function PboIntroductoryScreen() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSave = async () => {
    const response = await request('/redirect-url', { method: 'GET' });
    const { success, data = { record: {} } } = response;
    if (success) {
      const { record } = data;
      if (record.salesforceUrl && record.clientId && record.redirectUrl) {
        const {
          salesforceUrl, clientId, redirectUrl, codeChallenge, codeChallengeMethod, state,
        } = record;
        window.location.replace(`${salesforceUrl}?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}&state=${state}`);
      } else {
        dispatch(openSnackbar({ open: true, message: 'Failed to get Connect PBO URL', type: 'error' }));
      }
    } else {
      dispatch(openSnackbar({ open: true, message: 'Failed to get Connect PBO URL', type: 'error' }));
    }
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.requirementItemContainer}>
        <Typography variant="h2" className={classes.welcomeText} fontWeight="bold">
          Welcome
        </Typography>
        <Typography variant="body1" marginBottom="35px" gutterBottom>
          To ensure a smooth process, please verify that your Salesforce org meets the following requirements:
        </Typography>
        <RequirementItem
          heading="Enable App Analytics API"
          description={(
            <>
              Salesforce collects the daily event logs and serves them through App Analytics API. If you haven&apos;t enabled App analytics API, please
              {' '}
              <a
                href="https://doc.isvinsights.ai/docs/gettingStarted"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1976d2', textDecoration: 'underline' }}
              >
                click here
              </a>
              {' '}
              for instructions.
            </>
)}
          images={['Group 1.svg']}
        />
        <RequirementItem heading="Ensure you are using your PBO as LMO" description="Salesforce recommends installing the LMA in the PBO. The reason for that is simple: in order to assign an account to a license, the account record needs to exist in the same organization." images={['Group 2.svg']} />
      </Box>
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" gutterBottom>
                Access your organization&apos;s data instantly by clicking Connect PBO
              </Typography>
              <Button onClick={() => handleSave()} variant="contained" color="primary" className={classes.connectButton} startIcon={<CableIcon />}>
                Connect PBO
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src="/pboImage.svg" alt="alt" style={{ maxWidth: '100%' }} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default PboIntroductoryScreen;
